module.exports = __webpack_public_path__ + "img/1542514952.aed0f706.jpg";